/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Label_PasswordInputs */

const es_cap_label_password = /** @type {(inputs: Cap_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contraseña`)
};

const gl_cap_label_password = /** @type {(inputs: Cap_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrasinal`)
};

const en_cap_label_password = /** @type {(inputs: Cap_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password`)
};

/**
* | output |
* | --- |
* | "Password" |
*
* @param {Cap_Label_PasswordInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_label_password = /** @type {((inputs?: Cap_Label_PasswordInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Label_PasswordInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_label_password(inputs)
	if (locale === "en") return en_cap_label_password(inputs)
	return es_cap_label_password(inputs)
});